module.exports = __webpack_public_path__ + "media/level_1_chinese_song.97a11f52.mp3";